import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Rewards from './Rewards';
import Cashout from './cashout/Cashout';
import CashoutHistory from './cashout/CashoutHistory';
import CashoutTaxFaq from './cashout/CashoutTaxFaq';
import CashoutTerms from './cashout/CashoutTerms';
import CashoutEducate from './cashout/CashoutEducate';
import Convert from './convert/Convert';
import ItemConvert from './item-convert/ItemConvert';

export default function RewardsRoutes() {
  return (
    <Switch>
      <Route path="/" exact component={Rewards} />
      <Route path="/cash-out" component={Cashout} />
      <Route path="/convert" component={Convert} />
      <Route path="/educate" component={CashoutEducate} />
      <Route path="/history" component={CashoutHistory} />
      <Route path="/item-convert" component={ItemConvert} />
      <Route path="/tax-faq" component={CashoutTaxFaq} />
      <Route path="/terms" component={CashoutTerms} />
    </Switch>
  );
}
